import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink } from "react-router-dom";
import { getAEMUrl } from "@jti/fe-common";
import { isURLActive } from "../../utils/isURLActive/isURLActive";
import { LinkElementContent } from "./LinkElementContent";
import styles from "./NavBar.module.scss";
export function isSubpageActive(link) {
    const linkTo = String(link.to);
    return location.hash.indexOf(linkTo) > -1 && linkTo !== "/";
}
export const LinkElement = ({ link, isExternal, alwaysExternal }) => {
    const activeSubpage = isSubpageActive(link) ? styles.active : "";
    if (isExternal || alwaysExternal) {
        const linkTo = link.to ? `#${link.to}` : undefined;
        const url = getAEMUrl(linkTo, link.external);
        const className = [styles.link, isURLActive(url) ? styles.active : ""].join(" ").trim();
        return (_jsx("a", { className: className, href: url, "data-testid": "linkElementExternalLink", children: _jsx(LinkElementContent, { text: link.text }) }));
    }
    return (_jsx(NavLink, { className: `${styles.link} ${activeSubpage}`, to: link.to, activeClassName: styles.active, exact: true, children: _jsx(LinkElementContent, { text: link.text }) }));
};
//# sourceMappingURL=LinkElement.js.map